import React, { useState, useEffect } from "react";
import { HashLink } from "react-router-hash-link";

import logo from "../images/logo.png";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [scroll, setScroll] = useState(0);
  useEffect(() => {
    document.addEventListener("scroll", (event) => onScroll(), true);
  }, []);
  const onScroll = () => {
    let x = Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop
    );
    setScroll(x);
  };

  return (
    <>
      <h1 className="tekisyoku-logo">
        <img src={logo} alt="道新適職フェア" />
      </h1>
      <nav>
        <ul>
          <li>
            <HashLink smooth to="#top">
              道新適職フェア
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="#howto">
              参加方法
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="#joblist">
              求人一覧
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="#place">
              開催会場
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="#infection">
              感染対策について
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="#contact">
              お問い合わせ
            </HashLink>
          </li>
        </ul>
        <div className="fake-menuButton"></div>
      </nav>
      <div className={scroll !== 0 ? "appear" : "disappear"}>
        <div
          className={
            toggleMenu ? "menuButton openMenu" : "menuButton closeMenu"
          }
          onClick={() => {
            setToggleMenu(!toggleMenu);
          }}
        >
          <span></span>
        </div>
      </div>
      <div
        className={toggleMenu ? "overlay openMenu" : "overlay closeMenu"}
        onClick={() => {
          setToggleMenu(false);
        }}
      ></div>

      <div className={toggleMenu ? "menu openMenu" : "menu closeMenu"}>
        <ul>
          <li>
            <HashLink
              smooth
              to="#top"
              onClick={() => {
                setToggleMenu(false);
              }}
            >
              道新適職フェア
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#howto"
              onClick={() => {
                setToggleMenu(false);
              }}
            >
              参加方法
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#joblist"
              onClick={() => {
                setToggleMenu(false);
              }}
            >
              求人一覧
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#place"
              onClick={() => {
                setToggleMenu(false);
              }}
            >
              開催会場
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#infection"
              onClick={() => {
                setToggleMenu(false);
              }}
            >
              感染対策について
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#contact"
              onClick={() => {
                setToggleMenu(false);
              }}
            >
              お問い合わせ
            </HashLink>
          </li>
        </ul>
        <div className="buttonContainer">
          <button>
            お問い合わせ<i className="fas fa-external-link-square-alt"></i>
          </button>
          <button>
            企業様はこちら<i className="fas fa-external-link-square-alt"></i>
          </button>
        </div>
        <i
          className="fas fa-times"
          onClick={() => {
            setToggleMenu(false);
          }}
        ></i>
      </div>
    </>
  );
};

export default Navbar;
